import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import { i18n } from '@/boot/i18n';
import { FIB } from '@/config/constants';
var TOPIC_TYPE = FIB.TOPIC_TYPE,
    QUESTION_TYPE = FIB.QUESTION_TYPE;
import { makeQuestionScreen, addSubmitQuestion } from "./_utils";
import { selectBasedOnCounts, select } from "./_drilldownQuestionUtils";
/**
 * Extract the set of topics stores for a DD+ answer (as they are stored in a wonky format :()
 */

var resolveTopics = function resolveTopics(topics) {
  if (!topics) {
    return [];
  }

  return Array.isArray(topics) ? topics : [{
    value: topics === null || topics === void 0 ? void 0 : topics.value
  }];
};

export default {
  type: QUESTION_TYPE.QUESTION_TYPE_DRILLDOWN_PLUS,
  requiresTransaction: false,
  selectBasedOnCounts: selectBasedOnCounts,
  select: select,

  /**
   * Renders a Drilldown Plus Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var question, indicatorTopicObject, topics, topicOptions, topicInput, commentInput;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              question = context.question; // Find the topics for the question's indicator id (which is called topLevelRating annoyingly)

              indicatorTopicObject = context.survey.topics.find(function (topic) {
                return topic.indicatorId === question.topLevelRating;
              }); // DD+ questions only let you select from Complaint topics (filter by type)

              topics = (indicatorTopicObject ? indicatorTopicObject.topics : []).filter(function (topic) {
                return topic.type = TOPIC_TYPE.TOPIC_TYPE_COMPLAINT;
              });
              topicOptions = topics.map(function (topic) {
                return {
                  id: 'question' + question.id + 'topic' + topic.id,
                  label: topic.value,
                  value: topic.id
                };
              }); // prepare topic input

              topicInput = {
                id: 'question' + question.id + 'topic',
                type: 'fib-select',
                required: false,
                label: '',
                props: {
                  label: i18n.t('questions.common.dropdownPlaceholder'),
                  options: topicOptions
                },
                _meta: {
                  element: 'topic'
                }
              }; // prepare comments input

              commentInput = {
                id: 'question' + question.id + 'comment',
                type: 'fib-comments',
                required: false,
                label: question.text,
                props: {
                  label: question.text + '...',
                  rows: 4 // Give textarea a minimum height of 4 rows

                },
                _meta: {
                  element: 'comments'
                }
              }; // make question screen using DD+ component

              return _context.abrupt("return", makeQuestionScreen(context, [{
                id: 'question' + question.id + 'ddplus',
                type: 'fib-drill-down-plus',
                required: context.question.required,
                label: '',
                props: {
                  commentInput: commentInput,
                  topicInput: topicInput,
                  multiSelect: context.question.multiSelect
                }
              }], question, {
                title: question.text
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Get trigger answers for this question type.
   */
  getTriggerAnswers: function getTriggerAnswers(answer) {
    var _answer$value;

    return resolveTopics((_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.topics).map(function (t) {
      return t === null || t === void 0 ? void 0 : t.value;
    });
  },

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var response = context.response; // take first element in answers array to be the answer

    var answer = response && Array.isArray(response.answers) ? response.answers[0] : null; // take topic and comment from value passed in answer

    var val = answer ? answer.value : null;
    var comment = val ? val.comment : null;
    var topics = val && val.topics ? val.topics : null; // if no useful response, return null

    if (!comment && !topics) {
      return null;
    }

    return {
      text: comment || null,
      topics: topics,
      mutateSubmit: function mutateSubmit(submit) {
        var topics = resolveTopics(this.topics);

        for (var i = 0; i < topics.length; i++) {
          var topicValue = topics[i].value;

          if (topicValue) {
            addSubmitQuestion(submit, response, {
              text: this.text,
              choices: [topicValue]
            });
          }
        }
      }
    };
  }
};